import { z } from "zod";
import { photoRouletteCandidateSchema } from "./candidate.js";
import { photoRouletteLeaderboardEntrySchema } from "./leaderboard.js";

export const PHOTO_ROULETTE_MIN_OPTIONS_PER_ROUND = 2;
export const PHOTO_ROULETTE_MAX_OPTIONS_PER_ROUND = 4;
export const PHOTO_ROULETTE_OPTIONS_PER_ROUND = PHOTO_ROULETTE_MAX_OPTIONS_PER_ROUND;

export const photoRouletteRoundSchema = z.object({
	post_id: z.string(),
	photo_url: z.string(),
	correct_user_id: z.string(),
	options: z.array(photoRouletteCandidateSchema).min(PHOTO_ROULETTE_MIN_OPTIONS_PER_ROUND).max(PHOTO_ROULETTE_MAX_OPTIONS_PER_ROUND),
});

export type PhotoRouletteRound = z.infer<typeof photoRouletteRoundSchema>;

export const photoRoulettePerPlayerRoundResultSchema = z.object({
	user_id: z.string(),
	guessed_user_id: z.string().nullable(),
	answered_at: z.number().nullable(),
	response_time_ms: z.number().int().nonnegative().nullable(),
	is_correct: z.boolean(),
	base_points: z.number().int().nonnegative(),
	speed_bonus: z.number().int().min(0).max(5),
	streak_bonus: z.number().int().nonnegative(),
	points: z.number().int().nonnegative(),
	streak_after: z.number().int().nonnegative(),
});

export type PhotoRoulettePerPlayerRoundResult = z.infer<typeof photoRoulettePerPlayerRoundResultSchema>;

export const photoRouletteRankingEntrySchema = photoRouletteLeaderboardEntrySchema;

export type PhotoRouletteRankingEntry = z.infer<typeof photoRouletteRankingEntrySchema>;
